import Wrap from "../../components/wrap";

export default function PrivacyPolicyAndCookieUsage() {
    return (
        <section className="single-page">
            <Wrap>
                <div className="mx-auto overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">
                    <div className="border-b border-slate-200 bg-slate-50 px-8 py-8">
                        <h1 className="text-3xl font-bold text-slate-900 md:text-4xl">
                            Gizlilik Politikası ve Çerez Kullanımı
                        </h1>
                    </div>

                    <div className="space-y-10 px-8 py-8 leading-7 text-slate-700">
                        <section>
                            <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                                1. Veri Sorumlusu
                            </h2>

                            <p className="mt-4">
                                Bu politika, 6698 sayılı Kişisel Verilerin Korunması
                                Kanunu (“KVKK”) uyarınca veri sorumlusu sıfatıyla
                                Pixad Medya A.Ş. tarafından aydınlatma metnini
                                detaylandırmak ve sizi daha da bilgilendirmek amacıyla
                                hazırlanmıştır.
                            </p>
                        </section>

                        <section>
                            <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                                2. İşlenen Kişisel Veriler
                            </h2>

                            <p className="mt-4">
                                Web sitesine her erişimde sistem aşağıdaki verileri
                                toplayabilir:
                            </p>

                            <ul className="mt-4 list-disc space-y-2 pl-6">
                                <li>Tarayıcı türü ve versiyonu</li>
                                <li>İşletim sistemi</li>
                                <li>İnternet hizmet sağlayıcı</li>
                                <li>IP adresi</li>
                                <li>Erişim tarihi ve saati</li>
                                <li>Önceki ve sonraki ziyaretler</li>
                            </ul>

                            <p className="mt-4">
                                Bu veriler, site fonksiyonları ve güvenlik için
                                toplanır; doğrudan pazarlama amaçlı kullanılmaz.
                            </p>
                        </section>

                        <section>
                            <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                                3. Kişisel Verilerin İşlenme Amaçları
                            </h2>

                            <p className="mt-4">
                                Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
                            </p>

                            <ul className="mt-4 list-disc space-y-2 pl-6">
                                <li>Web sitesinin çalışmasının sağlanması</li>
                                <li>İletişim taleplerinin yanıtlanması</li>
                                <li>Hukuki yükümlülüklerin yerine getirilmesi</li>
                                <li>Bilgi güvenliği süreçlerinin yürütülmesi</li>
                                <li>Performans ve analiz süreçlerinin yürütülmesi</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                                5. Yurt Dışına Aktarım
                            </h2>

                            <p className="mt-4">
                                Web sitemiz üzerinden işlenen kişisel veriler yurt
                                dışına aktarılmamaktadır. Herhangi bir talep veya
                                faaliyetin gereği olarak aktarım yapılması gereken bir
                                durum hasıl olursa ilgilinin bu konuda açık rızası
                                alınarak aktarım gerçekleştirilebilir.
                            </p>
                        </section>

                        <section>
                            <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                                6. Özel Nitelikli Veriler
                            </h2>

                            <p className="mt-4">
                                Kişilerin ırkı, etnik kökeni, siyasi düşüncesi,
                                felsefi inancı, dini, mezhebi veya diğer inançları,
                                kılık ve kıyafeti, dernek, vakıf ya da sendika üyeliği,
                                sağlığı, cinsel hayatı, ceza mahkûmiyeti ve güvenlik
                                tedbirleriyle ilgili verileri ile biyometrik ve genetik
                                verileri özel nitelikli kişisel veridir.
                            </p>

                            <p className="mt-4">
                                Site kullanıcılarının özel nitelikli verileri hiçbir
                                şekilde tarafımızca işlenmediği gibi ileteceğiniz talep
                                ve mesajlarınızda da bu tür özel nitelikli verilerinize
                                yer vermemeniz gerekmektedir.
                            </p>
                        </section>

                        <section>
                            <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                                7. Çerez Kullanımı
                            </h2>

                            <p className="mt-4">
                                Pixad Medya A.Ş.’ye ait olan www.pixad.com.tr web
                                sitesi çerez (cookie) kullanan bir sitedir. Çerez;
                                kullanılmakta olan cihazın internet tarayıcısına ya da
                                sabit diskine depolanarak söz konusu cihazın tespit
                                edilmesine olanak tanıyan, çoğunlukla harf ve
                                sayılardan oluşan bir dosyadır.
                            </p>

                            <p className="mt-4">
                                www.Pixad.com.tr çerezleri; günlük dosyaları, boş gif
                                dosyaları ve/veya üçüncü taraf kaynakları yoluyla
                                topladığı bilgileri tercihlerinizle ilgili bir özet
                                oluşturmak amacıyla depolar.
                            </p>

                            <p className="mt-4">
                                Oturum çerezleri (session cookies) ve kalıcı çerezler
                                (persistent cookies) olmak üzere sitelerimiz genelinde
                                iki tür çerez kullanmaktayız. Oturum çerezleri geçici
                                çerezler olup sadece tarayıcınızı kapatıncaya kadar
                                geçerlidirler. Kalıcı çerezler siz silinceye veya
                                süreleri doluncaya (bu şekilde çerezlerin cihazında ne
                                kadar kalacağı, çerezlerin “kullanım ömürlerine” bağlı
                                olacaktır) kadar sabit diskinizde kalırlar.
                            </p>

                            <p className="mt-4">
                                www.pixad.com.tr çerezleri; yaptığınız tercihleri
                                hatırlamak ve web sitesi/mobil uygulama kullanımınızı
                                kişiselleştirmek için kullanır. Bu kullanım parolanızı
                                kaydeden ve web sitesi/mobil uygulama oturumunuzun
                                sürekli açık kalmasını sağlayan, böylece her
                                ziyaretinizde birden fazla kez parola girme zahmetinden
                                kurtaran çerezleri ve web sitesi/mobil uygulamaya daha
                                sonraki ziyaretlerinizde sizi hatırlayan ve tanıyan
                                çerezleri içerir.
                            </p>

                            <p className="mt-4">
                                www.pixad.com.tr web sitesine nereden bağlandığınız,
                                web sitesi/mobil uygulama üzerinde hangi içeriği
                                görüntülediğiniz ve ziyaretinizin süresi gibi web
                                sitesini/mobil uygulamayı nasıl kullandığınızın
                                ölçümlenmesi dahil olmak üzere web sitesini/mobil
                                uygulamayı nasıl kullandığınızı tespit etmek için
                                kullanır.
                            </p>

                            <p className="mt-4">
                                www.pixad.com.tr web sitesi çerezleri ayrıca; arama
                                motorlarını, web sitesi, mobil uygulamasını ve/veya web
                                sitesinin reklam verdiği internet sitelerini ziyaret
                                ettiğinizde ilginizi çekebileceğini düşündüğü reklamları
                                size sunabilmek için “reklam teknolojisini” devreye
                                sokmak amacıyla kullanabilir. Reklam teknolojisi, size
                                özel reklamlar sunabilmek için web sitesine/mobil
                                uygulamaya ve web sitesinin reklam verdiği web
                                sitelerine/mobil uygulamalarına yaptığınız önceki
                                ziyaretlerle ilgili bilgileri kullanır. Bu reklamları
                                sunarken, web sitesinin sizi tanıyabilmesi amacıyla
                                tarayıcınıza benzersiz bir üçüncü taraf çerezi
                                yerleştirilebilir.
                            </p>

                            <p className="mt-4">
                                Hizmet Veren ayrıca Google Inc. tarafından sağlanan bir
                                web analizi hizmeti olan Google Analytics kullanmaktadır.
                                Google Analytics, çerezleri kullanıcıların web sitesini,
                                mobil uygulamayı ve/veya mobil sitesini nasıl
                                kullandıklarını istatistiki bilgiler/raporlar ile analiz
                                etmek amacıyla kullanır. Google Analytics kullanımı
                                hakkında daha fazla bilgi için (reddetme seçenekleri
                                dahil), şu adresi ziyaret edebilirsiniz:
                            </p>

                            <p className="mt-3 break-all rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm">
                                http://www.google.com/intl/tr/policies/privacy/#infocollect
                            </p>

                            <p className="mt-4">
                                Mobil uygulamalarda çerez yerine ilgili uygulamanın
                                SDK&apos;sı (Software Development Kit) kullanılmaktadır.
                            </p>
                        </section>

                        <section>
                            <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                                Çerez Yönetimi
                            </h2>

                            <p className="mt-4">
                                Aşağıdaki yöntemleri kullanarak çerezlere izin verme ve
                                reddetme imkânını kullanabilirsiniz:
                            </p>

                            <div className="mt-6 grid gap-4 sm:grid-cols-2">
                                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                                    <strong>Google Chrome</strong>
                                    <p className="mt-2 text-sm leading-6">
                                        Tarayıcınızın adres bölümünde yer alan, “kilit
                                        işareti”ni tıklayarak, “Çerezler” sekmesinden
                                        çerezlere izin verebilir veya engelleyebilirsiniz.
                                    </p>
                                </div>

                                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                                    <strong>Internet Explorer</strong>
                                    <p className="mt-2 text-sm leading-6">
                                        Tarayıcınızın sağ üst bölümünde yer alan
                                        “Araçlar” bölümünden güvenlik sekmesini
                                        tıklayarak “izin ver” veya “izin verme” şeklinde
                                        çerezleri yönetebilirsiniz.
                                    </p>
                                </div>

                                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                                    <strong>Mozilla Firefox</strong>
                                    <p className="mt-2 text-sm leading-6">
                                        Tarayıcınızın sağ üst köşesinde yer alan “menüyü
                                        aç” sekmesini tıklayınız. “Seçenekler” görselini
                                        tıklayarak “Gizlilik ve Güvenlik” butonunu
                                        kullanarak çerezleri yönetebilirsiniz.
                                    </p>
                                </div>

                                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                                    <strong>Opera</strong>
                                    <p className="mt-2 text-sm leading-6">
                                        Tarayıcınızın “Tercihler” bölümünde
                                        “Gelişmiş”i seçerek “Çerezler” bölümünden çerez
                                        yönetimini yapabilirsiniz.
                                    </p>
                                </div>

                                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 sm:col-span-2">
                                    <strong>Safari</strong>
                                    <p className="mt-2 text-sm leading-6">
                                        Telefonunuzun “Ayarlar” bölümünden “Safari”
                                        sekmesini seçip, “Gizlilik ve Güvenlik”
                                        bölümünden tüm çerez yönetiminizi yapabilirsiniz.
                                    </p>
                                </div>
                            </div>

                            <p className="mt-6">
                                Yukarıdaki seçeneklerin yanı sıra; tüm çerezler hakkında
                                bilgi sahibi olmak ve çerez yönetimi için
                                allaboutcookies.org ve youronlinechoices.eu adreslerini
                                ziyaret edebilirsiniz veya “Privacy Badger”
                                uygulamasını kullanabilirsiniz.
                            </p>

                            <ul className="mt-4 list-disc space-y-2 pl-6 break-all">
                                <li>https://www.allaboutcookies.org</li>
                                <li>https://www.youronlinechoices.eu/</li>
                                <li>https://www.eff.org/tr/privacybadger</li>
                            </ul>

                            <p className="mt-4">
                                Kalıcı çerezleri veya oturum çerezlerini reddederseniz,
                                web sitesini, mobil uygulamayı ve mobil sitesini
                                kullanmaya devam edebilirsiniz fakat web sitesinin,
                                mobil uygulamanın ve mobil sitesinin tüm işlevlerine
                                erişemeyebilirsiniz veya erişiminiz sınırlı olabilir.
                            </p>
                        </section>
                    </div>
                </div>
            </Wrap>
        </section>
    );
}